import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { UserContext } from "../../contexts/UserContext";
import Form from "../../interface/Form";
import { useCheckUserExist } from "../authentication/useCheckUserExist";
import { useGetUserDetails } from "../authentication/useGetUserDetails";
import FormRow from "../../interface/FormRow";
import { useForm } from "react-hook-form";
import Input from "../../interface/Input";
import Button from "../../interface/Button";
import Label from "../../interface/Label";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const StyledContainer = styled.div`
  background-color: transparent;
  border-radius: var(--border-radius-lg);

  padding: 3.2rem 4rem;
  transition: all 0.5s;
`;

const ImageContainer = styled.div`
  display: flex;
  align-self: center;
`;

const StyledImage = styled.img`
  width: 15rem;
  height: 15rem;
  border-radius: 50%;
  border: 1px solid var(--color-grey-100);
  box-shadow: var(--shadow-btn);
`;

function InfoBasic() {
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);
  const [fetchedUserDetails, setFetchedUserDetails] = useState({});
  const { mutate: checkUser } = useCheckUserExist();
  const { mutate: getUserDetails } = useGetUserDetails();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: userDetails.userEmail,

      // Set other default values as needed
    },
  });

  useEffect(() => {
    // Set form default values on component mount or userDetails change
    setValue("email", userDetails.userEmail);
    // Update navbar with the current user's ID
    navigate(`/employees?id=${userDetails.userId}`, {
      replace: true,
    });
  }, [userDetails, setValue, navigate]);

  // No need to watch the "email" if we're not performing real-time validation or checks
  // const userEmail = watch("email");

  const isEmailEditable = userDetails.userAccessLevel === "Admin";

  const onSubmit = (data) => {
    console.log(data);
    // Handle form submission
    // You may want to include logic to update user details here
  };

  const handleEmailEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleEmailBlur(e);
    }
  };

  const handleEmailBlur = (e) => {
    const email = e.target.value;

    checkUser(email, {
      onSuccess: (exists) => {
        if (exists) {
          getUserDetails(email, {
            onSuccess: (response) => {
              if (response.userExists) {
                console.log("NewUser", response.data.data);
                setFetchedUserDetails(response.data.data);
                navigate(`/employees?id=${response.data.data.id}`, {
                  replace: true,
                });

                // Optionally, populate form fields with fetched data
                Object.keys(response.data).forEach((key) => {
                  setValue(key, response.data[key], { shouldValidate: true });
                });

                toast.success("User data retrieved.");
              }
            },
            onError: (error) => {
              toast.error(error);
            },
          });
        }
      },
      // Optionally, handle errors here as well
      onError: (error) => {
        toast.error(
          "Email is incorrect, or not registrered. You can add new user"
        );
      },
    });
  };

  return (
    <Form type="modal" onSubmit={handleSubmit(onSubmit)}>
      <FormRow label="Enter Email">
        <Input
          type="email"
          id="email"
          {...register("email", { required: true })}
          disabled={!isEmailEditable} // Disable if not admin
          onBlur={handleEmailBlur}
          onKeyDown={handleEmailEnter}
        />
      </FormRow>
      <FormRow label="Name">
        <Label>{fetchedUserDetails.userName || userDetails.userName}</Label>
      </FormRow>
      <FormRow label="Department">
        <Label>
          {fetchedUserDetails.department || userDetails.userDepartment}
        </Label>
      </FormRow>
      <FormRow label="Position">
        <Label>{fetchedUserDetails.position || userDetails.userPosition}</Label>
      </FormRow>
      <FormRow label="Skill">
        <Label>{fetchedUserDetails.skillSet || userDetails.userSkillSet}</Label>
      </FormRow>
      <ImageContainer>
        <StyledImage
          src={
            fetchedUserDetails.userImageBase64 ||
            userDetails.userImage ||
            "/images/DefaultUser.png"
          }
          alt="User Image"
        ></StyledImage>
      </ImageContainer>
    </Form>
  );
}

export default InfoBasic;
